module.exports = __webpack_public_path__ + "static/media/add-ball-white.390ad787.svg";